var module = angular.module('octopusApp.infrastructure');

// Simple logger
module.factory('octopusLog', function () {
  var instance = {};
  instance.isEnabled = true;

  var consoleWrapper = function (name) {
    var console = window.console;
    if (console && console[name]) {
      if (console[name].apply) {
        return function () {
          if (instance.isEnabled) {
            console[name].apply(console, arguments);
          }
        };
      } else {
        return function () {
          if (instance.isEnabled) {
            var message = Array.prototype.join.call(arguments, ', ');
            console[name](message);
          }
        };
      }
    }

    return function () {
      return this;
    };
  };

  instance.log = consoleWrapper('log');
  instance.info = consoleWrapper('info');
  instance.warn = consoleWrapper('warn');
  instance.error = consoleWrapper('error');
  instance.error = consoleWrapper('error');
  instance.enabled = function (b) {
    if (typeof (b) !== "undefined") {
      instance.isEnabled = b;
    }
    return instance.isEnabled;
  };
  return instance;
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/services/octopus_log.js
// module id = 702
// module chunks = 1